"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;
exports.waqi = exports.openaq = exports.aqicn = void 0;

var providers_1 = require("./providers");

var util_1 = require("./util");

function promisifyProvider(provider) {
  return __assign(__assign({}, provider), {
    fetchByGps: function fetchByGps(gps, options) {
      return util_1.teToPromise(provider.fetchByGps(gps, options));
    },
    fetchByStation: function fetchByStation(stationId, options) {
      return util_1.teToPromise(provider.fetchByStation(stationId, options));
    },
    normalizeByGps: function normalizeByGps(d) {
      return util_1.eitherToFunction(provider.normalizeByGps(d));
    },
    normalizeByStation: function normalizeByStation(d) {
      return util_1.eitherToFunction(provider.normalizeByStation(d));
    }
  });
}

exports.aqicn = promisifyProvider(providers_1.aqicn);
exports.openaq = promisifyProvider(providers_1.openaq);
exports.waqi = promisifyProvider(providers_1.waqi);